import React, { useState, useEffect } from "react";

const PrivateKeyType = ({ privateKey }) => {
  const [privateKeyType, setPrivateKeyType] = useState("");
  const PKCS1 = "-----BEGIN RSA PRIVATE KEY-----";
  const PKCS1_EXPLAIN = (
    <>
      Identified format is PEM with <a href="https://en.wikipedia.org/wiki/PKCS_1">PKCS#1</a>/
      OpenSSL: id_rsa, *.pem, *.der, *.key
    </>
  );
  const PKCS8_type1 = "-----BEGIN PRIVATE KEY-----";
  const PKCS8_type2 = "-----BEGIN ENCRYPTED PRIVATE KEY-----";
  const PKCS8_EXPLAIN = (
    <>
      Identified format is PEM with <a href="https://en.wikipedia.org/wiki/PKCS_8">PKCS#8</a>: *.pem,
      *.der, *.key
    </>
  );

  useEffect(() => {
    if (privateKey.includes(PKCS1)) {
      setPrivateKeyType(PKCS1_EXPLAIN);
    } else if (
      privateKey.includes(PKCS8_type1) ||
      privateKey.includes(PKCS8_type2)
    ) {
      setPrivateKeyType(PKCS8_EXPLAIN);
    } else {
      setPrivateKeyType("");
    }
  }, [privateKey]);

  return <>{privateKeyType}</>;
};
export default PrivateKeyType;
